import './AnalisisRiesgo.scss'
import React, {useState, useEffect} from 'react';
import {Row, Col, Form, Input, Upload, Button, Icon, notification, Progress, Radio, Table, List, Modal, message} from 'antd'
import { useTranslation, Trans } from 'react-i18next'
import moment from 'moment'
import { HistoryModal } from '../../../../../../layouts/Private/components'
import {getUbosCtrlPromise} from '../../../../promises'
import apiConfig from '../../../../../../config/api'
import { camelizerHelper } from '../../../../../../helpers';
import { updateRiskPromise, getRulesDetailPromise } from '../../../../promises';
import { FalsesPositivesBlock } from '../../../../../AlertManager/components';
import {AlertItems} from '../'

const UNASSIGNED = 'UNASSIGNED'

const RISK_ASSIGN_OPTIONS = [
    { value: 'GREEN', labelKey: 'messages.aml.risk.GREEN' },
    { value: 'YELLOW', labelKey: 'messages.aml.risk.YELLOW' },
    { value: 'ORANGE', labelKey: 'messages.aml.risk.ORANGE' },
    { value: 'RED', labelKey: 'messages.aml.risk.RED' },
    { value: 'BLACK', labelKey: 'messages.aml.risk.BLACK' },
]

const toSelectedRisk = (asignedRisk) => asignedRisk || UNASSIGNED
const isAssignedRiskValue = (value) => Boolean(value) && value !== UNASSIGNED
const getRiskTone = (value) => {
    if (!value || value === UNASSIGNED) return 'GRAY'
    return value
}

const AnalisisRiesgo = ({record, currentUser, handleRefreshItem, setRiskLocalStatus, forceExpand}) => {

    const [itemTable, setItemTable] = useState(record.clCliente);
    const [seeMore, setseeMore] = useState(true);
    const [ubos, setUbos] = useState(null);
    const [related, setRelated] = useState(null);
    const [isRiskVisible, setIsRiskVisible] = useState(false);
    const [tmpFilesList, setTmpFilesList] = useState([]);
    const [fileNames, setFileNames] = useState([]);
    const [riskComment, setRiskComment] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(null)
    const [userFileName, setUserFileName] = useState("");
    const [lastCommentRisk, setLastCommentRisk] = useState(itemTable.commentRisk);
    const [lastRiskDate, setLastRiskDate] = useState(null);
    const [detailsRisk, setDetailsRisk] = useState(null);
    const [falsosPositivos, setFalsosPositivos] = useState(null);
    const [selectedAlertItem, setSelectedAlertItem] = useState();
    const [selectedRisk, setSelectedRisk] = useState(toSelectedRisk(record.clCliente.asignedRisk));
    const [isModalRiskVisible, setIsModalRiskVisible] = useState(false);
    const [isReaffirming, setIsReaffirming] = useState(false);
    const { t } = useTranslation()

    useEffect(() => {
        getUbosCtrlPromise(itemTable.rut, currentUser.cliente.pais).then(ubos => {
            if(ubos.success) {
                setUbos(ubos.data)
            }else{
                message.error(t("messages.aml.errorGettingOwners"))
            }
        });

        if(itemTable.histRisks.length > 0){
            setLastRiskDate(moment(itemTable.histRisks[0].creationDate).format('DD/MM/YYYY HH:mm'));
        }

        if (currentUser.cliente.modules.includes('MONITOR')){
            getRulesDetailPromise(itemTable.id).then(rules => {
                setDetailsRisk(rules)
            })
        }else{
            setDetailsRisk(getRecordsRiskDetail(itemTable.compliance))
        }

        if(itemTable?.alert?.estadoFP === 'PENDIENTE' || itemTable?.alert?.estadoFP === 'TRATADO') {
            setFalsosPositivos(itemTable.alert)
        }else if(itemTable?.estadoFP === 'PENDIENTE' || itemTable?.estadoFP === 'TRATADO') {
            let rec = {record: itemTable, estadoFP: itemTable.estadoFP}
            setFalsosPositivos(rec)
        }
        if (record.entity && record.entity.propietarios) {
            setRelated(getRiskRelated(record))
        }
    }, []);

    const handleCloseRiskModal = () =>{
        setIsRiskVisible(false);
    }

    const handleOnChangeRisk = (value) => {
        const reaffirm = selectedRisk === value && isAssignedRiskValue(value) && itemTable.origRisk === "USER"
        setSelectedRisk(value)
        setIsReaffirming(reaffirm)
        setIsModalRiskVisible(true)
    }

    const handleRiskClick = (value) => {
        if (currentUser.type === 'AUDIT') return;
        if (selectedRisk === value && isAssignedRiskValue(value)) {
            handleOnChangeRisk(value)
        }
    }

    const handleCancelRiskModal = () => {
        setSelectedRisk(toSelectedRisk(itemTable.asignedRisk))
        setIsReaffirming(false)
        setIsModalRiskVisible(false)
    }

    const downloadReportRisk = (pdfFile) => {
        window.open(apiConfig.url + '/ubo/getPDFUboFinder?path=' + pdfFile)
    }

    const handleSaveRisk = () => {
        const formData = new FormData()
        if(tmpFilesList !== null && tmpFilesList.length > 0){
                tmpFilesList.forEach((file, index) => {
                formData.append('file', file)
                formData.append('fileName', fileNames[index])
            })
        }
        if (isAssignedRiskValue(selectedRisk)) {
            formData.append('risk', selectedRisk)
        }
        formData.append('commentRisk', riskComment)
        formData.append('id', itemTable.id);

        setConfirmLoading(true)
        updateRiskPromise(formData).then(res => {
            if(res.success){
                message.success(t("messages.aml.riskUpdated"));
                const tmpItem = { ...itemTable, histRisks: res.data.histRisks, risk: res.data.risk, asignedRisk: res.data.asignedRisk, origRisk: res.data.origRisk, fecRisk: res.data.fecRisk, commentRisk: res.data.commentRisk}
                setItemTable(tmpItem)
                setSelectedRisk(toSelectedRisk(res.data.asignedRisk))
                setLastRiskDate(moment(res.data.histRisks[0].creationDate).format('DD/MM/YYYY HH:mm'));
                setLastCommentRisk(res.data.commentRisk)
                setRiskComment(null)
                setIsReaffirming(false)
                setIsModalRiskVisible(false)
                setTmpFilesList([])

                setRiskLocalStatus({risk: res.data.risk, asignedRisk: res.data.asignedRisk, origRisk: res.data.origRisk, fecRisk: res.data.fecRisk, commentRisk: res.data.commentRisk})
            }else{
                setSelectedRisk(toSelectedRisk(itemTable.asignedRisk))
                setIsReaffirming(false)
                message.error(t("messages.aml.errorUpdatingRisk"));
            }
            setConfirmLoading(false)
        })
    }

    const handleListDeleted = (index) =>{
        setFileNames(oldFileNames => {
            const newFileNames = oldFileNames.slice();
            newFileNames.splice(index, 1)

            return newFileNames
        })

        setTmpFilesList(oldFileList => {
            const newFileList = oldFileList.slice();
            newFileList.splice(index, 1)

            return newFileList
        })
    }

    const ITEM_DESCRIPTION = {
        "PEPVTO": { list: t('messages.aml.holderObl'), db: t('messages.aml.activePEPS') },
        "PEPVTN": { list: t('messages.aml.holderNoObl'), db: t('messages.aml.activePEPS') },
        "PEPVRO": { list: t('messages.aml.relatedObl'), db: t('messages.aml.activePEPS') },
        "PEPVRN": { list: t('messages.aml.relatedNoObl'), db: t('messages.aml.activePEPS') },

        "FP": { list: t('messages.aml.civilServant'), db: t('messages.aml.civilServant') },

        "PEPI": { list: t("messages.aml.pep"), db: t("messages.aml.watchList") },
        "RCAI": { list: t('messages.aml.related'), db: t("messages.aml.watchList") },
        "WLSI": { list: t('messages.aml.specialInterest'), db: t("messages.aml.watchList") },
        "WLSAN": { list: t('messages.aml.sanctioned'), db: t("messages.aml.watchList") },
        "WLOOL": { list: t('messages.aml.otherLists'), db: t("messages.aml.watchList") },
        "UAF": { list: t('messages.aml.uafLists'), db: t("messages.aml.watchList") },
        "MAM": { list: t('messages.aml.mam.title'), db: t('messages.aml.mam.title') },

        "NEG": { list: t('messages.aml.ownLists'), db: t('messages.aml.ownLists') },

        "PEPHTO": { list: t('messages.aml.holderObl'), db: t('messages.aml.historicalPEPS') },
        "PEPHTN": { list: t('messages.aml.holderNoObl'), db: t('messages.aml.historicalPEPS') },
        "PEPHRO": { list: t('messages.aml.relatedObl'), db: t('messages.aml.historicalPEPS') },
        "PEPHRN": { list: t('messages.aml.relatedNoObl'), db: t('messages.aml.historicalPEPS') },

        "PEPC": { list: t('messages.aml.holder'), db: t('messages.aml.candidates') },
        "RCAC": { list: t('messages.aml.related'), db: t('messages.aml.candidates') },

        "AMESI": { list: t('messages.aml.specialInterest'), db: t("messages.aml.adverseMedia") },
        "AMESAN": { list: t('messages.aml.sanctioned'), db: t("messages.aml.adverseMedia") },
        "AMEOOL": { list: t('messages.aml.otherLists'), db: t("messages.aml.adverseMedia") },

        "BPI": { list: t('messages.aml.personsOfInterest'), db: t('messages.aml.personsOfInterest') },

        "VIP": { list: t("messages.aml.vip"), db: t("messages.aml.vip") },

        "PJUD-C": { list: t('messages.aml.civilCauses'), db: t('messages.aml.powerOfAttorney') },
        "PJUD-P": { list: t('messages.aml.criminalCauses'), db: t('messages.aml.powerOfAttorney') },
        "PJUD-LAB": { list: t('messages.aml.laborCauses'), db: t('messages.aml.powerOfAttorney') },
        "PJUD-COB": { list: t('messages.aml.collectionCauses'), db: t('messages.aml.powerOfAttorney') },
        "PJUD-APE": { list: t('messages.aml.courtAppeals'), db: t('messages.aml.powerOfAttorney') },
        "PJUD-SUP": { list: t('messages.aml.supremeCourt'), db: t('messages.aml.powerOfAttorney') },

        "SOCBRD": { list: t("messages.aml.boardMember"), db: t("messages.aml.stateOwnedCompanies") },
        "SOCSOC": { list: t("messages.aml.stateOwnedCompanies"), db: t("messages.aml.stateOwnedCompanies") },

        "ONB-NAT": { list: t('messages.aml.titles.ONB-NAT'), db: t("messages.aml.onboarding") },
        "ONB-EXP": { list: t('messages.aml.titles.ONB-EXP'), db: t("messages.aml.onboarding") },
        "ONB-CONS": { list: t('messages.aml.titles.ONB-CONS'), db: t("messages.aml.onboarding") },
        "ONB-MAT": { list: t('messages.aml.titles.ONB-MAT'), db: t("messages.aml.onboarding") },
        ...(currentUser.cliente.pais === 'PER' && {
            "ONB-PROVI": { list: t('messages.aml.titles.ONB-PROVI'), db: t("messages.aml.onboarding") }
        }),
        "ONB-OCTO": { list: t('messages.aml.titles.ONB-OCTO'), db: t("messages.aml.onboarding") },
        "ONB-DONA": { list: t('messages.aml.titles.ONB-DONA'), db: t("messages.aml.onboarding") },
        "ONB-REPR": { list: t('messages.aml.titles.ONB-REPR'), db: t("messages.aml.onboarding") },
        "ONB-CI": { list: t('messages.aml.titles.ONB-CI'), db: t("messages.aml.onboarding") },
        "ONB-ACTE": { list: t('messages.aml.titles.ONB-ACTE'), db: t("messages.aml.onboarding") },
        "ONB-FP": { list: t('messages.aml.titles.ONB-FP'), db: t("messages.aml.onboarding") },
        "ONB-TSA": { list: t('messages.aml.titles.ONB-TSA'), db: t("messages.aml.onboarding") },
        "ONB-TSM": { list: t('messages.aml.titles.ONB-TSM'), db: t("messages.aml.onboarding") },
        "ONB-TSB": { list: t('messages.aml.titles.ONB-TSB'), db: t("messages.aml.onboarding") },
        "ONB-PEP": { list: t('messages.aml.titles.ONB-PEP'), db: t("messages.aml.onboarding") }
    }

    const getRecordsRiskDetail = (compliance) => {
        let records = []
        if(compliance) {
            if(compliance?.PEPSAN?.riskBases) {
                Object.keys(compliance.PEPSAN.riskBases).map(list =>
                    records.push({type: t('messages.aml.mandatoryLists'), list: ITEM_DESCRIPTION[list].list, db: ITEM_DESCRIPTION[list].db, risk: compliance.PEPSAN.riskBases[list]})
                )
            }
            if(compliance?.KYCAME?.riskBases) {
                Object.keys(compliance.KYCAME.riskBases).map(list =>
                    records.push({type: t('messages.aml.kycKnowYourCustomer'), list: ITEM_DESCRIPTION[list].list, db: ITEM_DESCRIPTION[list].db, risk: compliance.KYCAME.riskBases[list]})
                )
            }
            if(compliance?.UBOCOM?.riskBases) {
                Object.keys(compliance.UBOCOM.riskBases).map(list =>
                    records.push({type: t('messages.aml.uboCompanies'), list: ITEM_DESCRIPTION[list].list, db: ITEM_DESCRIPTION[list].db, risk: compliance.UBOCOM.riskBases[list]})
                )
            }
            if(compliance?.ONB?.riskBases) {
                Object.keys(compliance.ONB.riskBases).map(list =>
                    records.push(
                        {type: t('messages.aml.onboarding'),
                            list: ITEM_DESCRIPTION[list].list,
                            db: ITEM_DESCRIPTION[list].db,
                            risk: compliance.ONB.riskBases[list]})
                )
            }
        }
        return records
    }

    const localeObj = {
        emptyText: t('messages.aml.noData'),
    }

    const riskSchema = [
        {
            title: t('messages.aml.date'),
            dataIndex: 'creationDate',
            cols: 4
        },
        {
            title: t('messages.aml.name'),
            dataIndex: 'userName',
            cols: 8
        },
        {
            title: t('messages.aml.risk'),
            dataIndex: 'risk',
            cols: 12
        },
    ];

    const RISK_DESCRIPTION={
        BLACK: t("messages.aml.risk.BLACK"),
        RED: t("messages.aml.risk.RED"),
        ORANGE: t("messages.aml.risk.ORANGE"),
        YELLOW: t("messages.aml.risk.YELLOW"),
        GREEN: t("messages.aml.risk.GREEN"),
        GRAY: t("messages.aml.notAssigned"),
        UNASSIGNED: t("messages.aml.risk.UNASSIGNED")
    }

    const getRiskLabel = (value) => {
        if (!value) return t("messages.aml.nA")
        return RISK_DESCRIPTION[value] || t("messages.aml.risk."+value)
    }

    const ubosColumns = [
        {
            key:1,
            dataIndex: itemTable.type === 'Person' || (ubos && ubos.ubos && ubos.ubos.length === 0) ? 'participacionDirecta' : 'participacion',
            width: '20%',
            render: (porcent) => {
            return <div className="porcent-onb-modal">{porcent ? (Math.round(porcent * 100)/100)+'%' : 'N/A' }</div>
            }
        },
        {
            key:2,
            dataIndex: 'name',
            width: '15%',
            render: () => {
            return <div className="prop-onb-modal">p</div>
            }
        },
        {
            key:3,
            dataIndex: 'name',
            ellipsis: true,
        },
    ]

    const getRiskRelated = (data) => {
        let rows = []
        if (data.entity) {
          for (let i = 0; i < data.entity.propietarios.length; i++) {
            if (data.entity.propietarios[i].amlStatus && data.entity.propietarios[i].amlStatus !== 'GREEN') {
              rows.push(data.entity.propietarios[i])
            }
          }
        }
        console.log(rows)
        return rows
    }

    const propsUpload = {
        accept: ".pdf, .png, .docx, .xlsx",
        onRemove: file => {
            const index = tmpFilesList.indexOf(file);
            handleListDeleted(index);
        },
        beforeUpload: file => {
            const validFiles = file.type === 'application/pdf' || file.type === 'image/png'|| file.name.endsWith('.docx') || file.name.endsWith('.xlsx');
            if (!validFiles) {
            message.error(t('messages.aml.formatNotAllowed'));
            }else{
            const validSize = file.size / 1024 / 1024 < 2;
            if (!validSize) {
                message.error(t('messages.aml.maxSize2MB'));
            }else{
                if(userFileName === "" || userFileName === null){
                message.error(t("messages.aml.mustEnterFileName"))
                }else{
                setTmpFilesList(oldTmpFilesList => [...oldTmpFilesList, file]);
                setFileNames(oldFileNames => [...oldFileNames, userFileName]);
                }
            }
            setUserFileName(null)
            }
            return false
        },
        multiple: false,
        showUploadList: false
    }

    const getDetailsColumns = () => {
        let columns = []
        if (currentUser.cliente.modules.includes('MONITOR')){
            columns.push(
            {
                key: 1,
                title: t("messages.aml.type"),
                dataIndex: 'type',
                render: (type) => {
                return t("messages.aml.compliance."+type)
                }
            },
            {
                key: 2,
                title: t("messages.aml.rule"),
                dataIndex: 'rule'
            },
            {
                key: 3,
                title: t("messages.aml.alertsNumber"),
                className: "codeColumn",
                dataIndex: 'alerts',
                onCell: (record) => {
                return {
                    onClick: () => {
                        setSelectedAlertItem(record)
                    },
                }
                }
            },
            {
                key: 4,
                title: t("messages.aml.risk"),
                dataIndex: 'risk',
                render: (riesgo) => (
                <div className={"risk-"+riesgo} style={{textAlign:"center", borderRadius:8, border: '1px solid rgb(158, 158, 158)'}}>
                    {RISK_DESCRIPTION[riesgo]}
                </div>
                )
            }
            )
        }else{
            columns.push(
            {
                key: 5,
                title: t("messages.aml.type"),
                dataIndex: 'type'
            },
            {
                key: 6,
                title: t("messages.aml.database"),
                dataIndex: 'db'
            },
            {
                key: 7,
                title: t("messages.aml.listCrossed"),
                dataIndex: 'list'
            },
            {
                key: 8,
                title: t("messages.aml.risk"),
                dataIndex: 'risk',
                render: (riesgo) => (
                <div className={"risk-"+riesgo} style={{textAlign:"center", borderRadius:8, border: '1px solid rgb(158, 158, 158)'}}>
                    {RISK_DESCRIPTION[riesgo]}
                </div>
                )
            }
            )
        }
        return columns;
    }

    const getTypeRelated = (type) => {
        if(type === "REP_LEGAL") return t('messages.aml.repLegal')
        else if(type === "DIRECTOR") return t("messages.aml.director")
        else if(type === "GERENTE_GENERAL") return t("messages.aml.manager")
        else if(type === "EJ_PRINCIPAL") return t("messages.aml.executivePrincipal")
        else if(type === "AVAL") return t("messages.aml.guarantor")
        else if(type === "APODERADO") return t("messages.aml.attorney")
        else return type
    }

    const riskTableColumns = [
        {
            key: 1,
            title: t('messages.aml.type'),
            dataIndex: 'type',
            width: 100,
            render: (text, record) => {
                if (text === 'Entity') {
                return t('messages.aml.entity')
                } else if(record.origenMallaPropiedad === 'CLIENTE'){
                return t("messages.aml.ubo")
                }else {
                return getTypeRelated(record.origenMallaPropiedad)
                }
            }
        },
        {
            key: 2,
            title: t('messages.aml.rut'),
            dataIndex: 'rut',
            width: 100,
            render: (text, record) => {
                if (record.pais === 'NACIONAL') {
                return text
                }
            }
        },
        {
            key: 3,
            title: t('messages.aml.name'),
            dataIndex: 'name',
            width: 220,
            render: (text) => camelizerHelper(text)
        },
        {
            key: 4,
            title: t('messages.aml.risk'),
            dataIndex: 'amlStatus',
            width: 70,
            render: (text) => <div className={'risk risk-' + text} />
        },
        {
            key: 5,
            title: t('messages.aml.module'),
            dataIndex: 'baseAml',
            width: 150
        },
        {
            key: 6,
            title: t('messages.aml.download'),
            dataIndex: 'pdfFile',
            width: 80,
            render: (text) => <Button type="primary" icon="file-pdf" size="small" onClick={(e) => downloadReportRisk(text)} />
        }
      ]

    const amlStatusRisk = (currentUser.cliente.modules.includes('MONITOR-AML') && itemTable.amlStatus) ?? 'GRAY'

    const getRiskTo = (selectedRisk) => {
        return selectedRisk === UNASSIGNED ? (amlStatusRisk??UNASSIGNED) : selectedRisk
    }


    return (
        <div className="ficha-analisis-riesgo">
            <Row className="field-section-row">
                <Col span={22}>
                    <h3>{t("messages.aml.analysisRisk")}</h3>
                </Col>
                <Col span={2} style={{textAlign:'right'}}>
                    <Button type="link" onClick={() => {setseeMore(!seeMore)}}>
                    {seeMore ?
                        <>{t("messages.aml.seeLess")} <Icon type="minus"/></>
                        :
                        <>{t("messages.aml.seeMore")} <Icon type="plus"/></>
                    }
                    </Button>
                </Col>
            </Row>
            <hr/>
            {seeMore &&
                <div className={!forceExpand ? "div-more-info" : ""} style={{padding: 10}}>
                    <div className="riesgo-fields-section-wrapper">
                        <div className={"general-risk-bar general-risk-bar-" + (itemTable.risk || "GRAY")}>
                            <div className="general-risk-summary">
                                <strong className="general-risk-title">{t("messages.aml.currentRisk")}</strong>
                                <div className={"child-risk-onb risk-" + (itemTable.risk || "GRAY")}>
                                    {itemTable.risk ? t("messages.aml.risk."+itemTable.risk) : t("messages.aml.nA")}
                                </div>
                            </div>
                            <div className="general-risk-details">
                                {itemTable.origRisk &&
                                    <div>
                                        <strong>{t("messages.aml.riskOrigin")}:</strong>{' '}
                                        {t("messages.aml.riskOrigin."+itemTable.origRisk)}
                                    </div>
                                }
                                {itemTable.fecRisk &&
                                    <div>
                                        <strong>{t("messages.aml.lastUpdate")}:</strong>{' '}
                                        {moment(itemTable.fecRisk).format('DD/MM/YYYY HH:mm')}
                                    </div>
                                }
                            </div>
                        </div>
                        <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <strong>{t("messages.aml.reassignedRisk")}</strong>
                                </Col>
                                <Col style={{marginTop:10, marginBottom:10}}>
                                    <div className= "radioBtn-wrapper-record">
                                        <Radio.Group
                                            className={"radioGroupOnbRisk-"+(isAssignedRiskValue(selectedRisk) ? selectedRisk : amlStatusRisk ?? 'GRAY')}
                                            size="large"
                                            value={selectedRisk}
                                            name="radioRiskObn"
                                            buttonStyle="solid"
                                            onChange={(e) => currentUser.type !== 'AUDIT' && handleOnChangeRisk(e.target.value)}
                                        >
                                            <Radio.Button value={"UNASSIGNED"} className={"aml-risk-option risk-"+amlStatusRisk + (itemTable.origRisk !== "USER" ? " risk-selected" : "")} style={{width:'100%'}}>
                                                <span className="aml-risk-option-content">
                                                    <div>{t("messages.aml.amlRisk")} <span style={{fontSize:'.7em'}}>({getRiskLabel(amlStatusRisk)})</span></div>
                                                    {itemTable.fecAMLStatus &&
                                                        <span className="aml-risk-option-date">
                                                            {t("messages.aml.lastUpdate")}: {moment(itemTable.fecAMLStatus).utc().format('DD/MM/YYYY HH:mm')}
                                                        </span>
                                                    }
                                                </span>
                                            </Radio.Button>
                                            {RISK_ASSIGN_OPTIONS.map((option) => (
                                                <Radio.Button key={option.value} className={itemTable.origRisk === "USER" && option.value === selectedRisk ? " risk-selected" : ""} value={option.value} onClick={() => handleRiskClick(option.value)}>
                                                    {t(option.labelKey)}
                                                </Radio.Button>
                                            ))}
                                        </Radio.Group>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    {t("messages.aml.justificationComment")}
                                    <Input.TextArea
                                    // onChange={(e) => {setRiskComment(e.target.value)}} 
                                    readOnly
                                    value={(!lastCommentRisk || lastCommentRisk === "null") ? t("messages.aml.noComments") : lastCommentRisk}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <div>
                                    {t("messages.aml.lastComment")}: {lastRiskDate ? lastRiskDate : t("messages.aml.withoutComments")}
                                    </div>
                                </Col>
                                <Col span={6} offset={12} style={{textAlign: 'right'}}>
                                    {lastRiskDate &&
                                    <Button onClick={() => setIsRiskVisible(true)} style={{padding:'unset'}}type="link">{t("messages.aml.viewPreviousComments")}</Button>
                                    }
                                </Col>
                            </Row>
                            {isRiskVisible &&
                                <HistoryModal schema={riskSchema} data={itemTable.histRisks} closeHandler={handleCloseRiskModal} recordId={itemTable.id}/>
                            }
                        </Col>
                        </Row>
                    </div>
                    {isModalRiskVisible &&
                        <Modal
                        title={t("messages.aml.editRisk")}
                        wrapClassName="modal-confirm-risk"
                        visible={ true }
                        width={ 600 }
                        okText={t("messages.aml.accept")}
                        cancelText={t("messages.aml.cancel")}
                        confirmLoading={confirmLoading}
                        onOk={() => {
                            if (riskComment){
                            if (tmpFilesList.length === 0 && userFileName !== ""){
                                notification.error({message: t("messages.aml.mustSelectFile")})
                            }else{
                                handleSaveRisk()
                            }
                            }else{
                            notification.error({message: t("messages.aml.mustEnterComment")})
                            }
                        }}
                        onCancel={handleCancelRiskModal}
                        >
                        <>
                            <Row>
                            {isReaffirming ?
                                <>
                                    <Trans
                                        i18nKey="messages.aml.dearUserReaffirm"
                                        values={{ name: currentUser.name, risk: getRiskLabel(selectedRisk) }}
                                        components={{ risk: <span className={"risk-label-chip risk-" + getRiskTone(selectedRisk)} /> }}
                                    /> <strong>{itemTable.nombre}</strong>. <br/>
                                </>
                                :
                                <>
                                    {t("messages.aml.dearUser", {name: currentUser.name})} <strong>{itemTable.nombre}</strong>. <br/>
                                    <Trans
                                        i18nKey="messages.aml.dearUserChangeFromTo"
                                        values={{ fromRisk: getRiskLabel(itemTable.risk), toRisk: getRiskLabel(getRiskTo(selectedRisk)) }}
                                        components={{
                                            fromRisk: <span className={"risk-label-chip risk-" + getRiskTone(itemTable.risk)} />,
                                            toRisk: <span className={"risk-label-chip risk-" + getRiskTone(getRiskTo(selectedRisk))} />
                                        }}
                                    /> <br/>
                                </>
                            }
                            {t("messages.aml.suggestComment")}
                            </Row>
                            <Row style={{marginTop:20}}>
                            <Input.TextArea
                                onChange={(e) => {setRiskComment(e.target.value)}} 
                                maxLength={4000}
                                placeholder={t("messages.aml.maxCharacters")}
                            />
                            </Row>
                            <Row style={{marginTop:25}}>
                            {t("messages.aml.addDocumentation")}
                            </Row>
                            <Row style={{marginTop: 15}}>
                                <Col span={16}>
                                    <Form.Item>
                                        <Input
                                            placeholder={t("messages.aml.enterDocumentName")}
                                            autoComplete="off"
                                            onChange={(e) => setUserFileName(e.target.value) }
                                            value={userFileName}
                                        />
                                    </Form.Item>
                                </Col>
                            <Col span={7} offset={1}>
                                <Upload {...propsUpload} >
                                <Button disabled={tmpFilesList.length > 9} style={{marginTop:4}} >
                                    <Icon type="upload" /> {t("messages.aml.uploadFile")}
                                </Button>
                                </Upload>
                            </Col>
                            </Row>
                            {tmpFilesList.length > 0 &&
                            <Row>
                                <List
                                size="small"
                                header={t("messages.aml.attachedDocuments")}
                                itemLayout="horizontal"
                                dataSource={tmpFilesList.map((file, index)=> {return {fileName: file.name, docName: fileNames[index], index: index}})}
                                renderItem={item => (
                                    <List.Item
                                    actions={[<Button type="link" onClick={() => handleListDeleted(item.index)}>{t("messages.aml.delete")}</Button>]}
                                    >
                                    <List.Item.Meta
                                        description={item.docName}
                                    />
                                    <List.Item.Meta
                                        description={item.fileName}
                                    />
                                    </List.Item>
                                )}
                                />
                            </Row>
                            }
                        </>
                        </Modal>
                    }
                    <div className="riesgo-fields-section-wrapper" style={{marginTop:10}}>
                        {currentUser.cliente.modules.includes('MONITOR-AML') && itemTable.compliance && itemTable.compliance.total > 0 &&
                        <Row style={{padding:'0px 0px 10px 2px'}}>{t("messages.aml.identifiedMatches", {total: itemTable.compliance.total, plural: itemTable.compliance.total > 1 ? 's' : ''})}</Row>
                        }
                        <Row type="flex" gutter={[6,0]}>
                        { currentUser.cliente.modules.includes('MONITOR-AML') &&
                            <Col span={9} style={{display: 'flex', flexWrap: 'nowrap', flexDirection: 'column'}}>
                            <div className="field-section-row-wrapper">
                                <Row>
                                    <div className="header-card-onb-form">
                                        {t("messages.aml.compliance")}
                                    </div>
                                </Row>
                                <Row>
                                    <Col span={itemTable.compliance?.ONB ? 6 : 8}>
                                        <div className="title-card-onb-form">
                                        {t("messages.aml.mandatoryLists")}
                                        </div>
                                    </Col>
                                    <Col span={itemTable.compliance?.ONB ? 6 : 8}>
                                        <div className="title-card-onb-form">
                                        {t("messages.aml.kyc")}
                                        </div>
                                    </Col>
                                    <Col span={itemTable.compliance?.ONB ? 6 : 8}>
                                        <div className="title-card-onb-form">
                                        {t("messages.aml.uboCompanies")}
                                        </div>
                                    </Col>
                                    { itemTable.compliance?.ONB &&
                                        <Col span={6}>
                                        <div className="title-card-onb-form">
                                            {t("messages.aml.onboarding")}
                                        </div>
                                        </Col>
                                    }
                                </Row>
                                <Row>
                                    <Col span={itemTable.compliance?.ONB ? 6 : 8}>
                                        <div className="item-risk-align">
                                        <div className={ 'child-risk-onb-circle risk-' + (itemTable.compliance && itemTable.compliance.PEPSAN && itemTable.compliance.PEPSAN.color ? itemTable.compliance.PEPSAN.color : "GRAY") }>
                                            {itemTable.compliance && itemTable.compliance.PEPSAN && itemTable.compliance.PEPSAN.bases && itemTable.compliance.PEPSAN.bases.length}
                                        </div>
                                        </div>
                                    </Col>
                                    <Col span={itemTable.compliance?.ONB ? 6 : 8}>
                                        <div className="item-risk-align">
                                        <div className={ 'child-risk-onb-circle risk-' + (itemTable.compliance && itemTable.compliance.KYCAME && itemTable.compliance.KYCAME.color ? itemTable.compliance.KYCAME.color : "GRAY") }>
                                            {itemTable.compliance && itemTable.compliance.KYCAME && itemTable.compliance.KYCAME.bases && itemTable.compliance.KYCAME.bases.length}
                                        </div>
                                        </div>
                                    </Col>
                                    <Col span={itemTable.compliance?.ONB ? 6 : 8}>
                                        <div className="item-risk-align">
                                        <div className={ 'child-risk-onb-circle risk-' + (itemTable.compliance && itemTable.compliance.UBOCOM && itemTable.compliance.UBOCOM.color ? itemTable.compliance.UBOCOM.color : "GRAY") }>
                                            {itemTable.compliance && itemTable.compliance.UBOCOM && itemTable.compliance.UBOCOM.bases && itemTable.compliance.UBOCOM.bases.length}
                                        </div>
                                        </div>
                                    </Col>
                                    { itemTable.compliance?.ONB &&
                                        <Col span={6}>
                                        <div className="item-risk-align">
                                            <div className={ 'child-risk-onb-circle risk-' + (itemTable.compliance && itemTable.compliance.ONB && itemTable.compliance.ONB.color ? itemTable.compliance.ONB.color : "GRAY") }>
                                            {itemTable.compliance && itemTable.compliance.ONB && itemTable.compliance.ONB.bases && itemTable.compliance.ONB.bases.length}
                                            </div>
                                        </div>
                                        </Col>
                                    }
                                </Row>
                            </div>
                            </Col>
                        }
                        <Col span={currentUser.cliente.modules.includes('MONITOR-AML') ? 9 : 24}>
                            <div className="field-section-row-wrapper">
                                <Row>
                                    <div className="header-card-onb-form">
                                    {t("messages.aml.societiesOwners")}
                                    </div>
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <div className="table-col-wrapper-onb">
                                            <Table
                                                dataSource={ubos === null ? null : (itemTable.type === 'Person' || (ubos?.ubos?.length === 0)) ? ubos.psoc : ubos.ubos}
                                                columns={ubosColumns}
                                                showHeader={false}
                                                tableLayout="fixed"
                                                scroll={{y: (ubos?.ubos?.length > 3 ?? ubos?.psoc?.length > 3) ? 120 : false}}
                                                style={{overflowX: 'hidden'}}
                                                pagination={false}
                                                loading = {ubos === null}
                                                locale = {localeObj}
                                            />
                                        </div>
                                    </Col>
                                    {/* <Col span={6}>
                                    <div className="text-5mas-wrapper">
                                        y 5 más...
                                    </div>
                                    </Col> */}
                                </Row>
                            </div>
                        </Col>
                        { currentUser.cliente.modules.includes('MONITOR-AML') &&
                            <Col span={6}>
                                <div className="field-section-row-wrapper">
                                    <Row>
                                        <div className="header-card-onb-form">
                                            {t("messages.aml.relevance")}
                                        </div>
                                    </Row>
                                    <Row>
                                        <div className="progress-flat-wrapper">
                                            <Progress
                                            // type="circle"
                                            percent={itemTable.compliance && itemTable.compliance.percent}
                                            status="normal"
                                            width={80}
                                            />
                                        </div>
                                    </Row>
                                    {itemTable.pdfFile &&
                                    <Row>
                                        <div className="progress-button-wrapper">
                                        <Button style={{marginBottom: 10}} onClick={() =>{downloadReportRisk(itemTable.pdfFile)}}>{t("messages.aml.viewCertificate")}</Button>
                                        </div>
                                    </Row>
                                    }
                                </div>
                            </Col>
                        }
                        </Row>
                    </div>
                    {currentUser.cliente.modules.includes('MONITOR-AML') && itemTable.compliance && itemTable.amlStatus && itemTable.amlStatus !== 'GREEN' &&
                        <div className="riesgo-fields-section-wrapper" style={{marginTop:10, marginBottom: 15}}>
                            <Row>
                                <Col span={24}>
                                    <div className="title-section">
                                        <Row>
                                            <Col span={22}>
                                                <h4>{t("messages.aml.detail")}</h4>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col span={15} style={{marginTop:10}}>
                                    <Table
                                        loading={detailsRisk === null}
                                        dataSource={detailsRisk}
                                        columns={getDetailsColumns()}
                                        pagination={false}
                                        bordered
                                    />
                                </Col>
                            </Row>
                            { related && related.length > 0 &&
                                <Row style={{marginTop:15}}>
                                    <Col span={24}>
                                        <div className="title-section">
                                            <Row>
                                                <Col span={22}>
                                                    <h4>{t("messages.aml.relatedDetail")}</h4>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                    <Col span={15} style={{marginTop:10}}>
                                        <Table
                                            dataSource={related}
                                            columns={riskTableColumns}
                                            bordered
                                            size="small"
                                            pagination={!forceExpand && related?.length > 10}
                                        />
                                    </Col>
                                </Row>
                            }
                        </div>
                    }
                    {selectedAlertItem &&
                        <Modal
                        wrapClassName="modal-detail-risk-alerts"
                        visible={true}
                        onCancel={() => setSelectedAlertItem(null)}
                        width={1000}
                        footer={[
                            <Button key="back" onClick={() => setSelectedAlertItem(null)}>
                                {t("messages.aml.btnClose")}
                            </Button>
                        ]}
                        >
                            <AlertItems currentUser={currentUser} selectedAlertItem={selectedAlertItem} recordId={itemTable.id}/>
                        </Modal>
                    }
                    {falsosPositivos &&
                        <FalsesPositivesBlock alert={falsosPositivos} refreshHandler={handleRefreshItem} view="new" />
                    }
                </div>
            }
        </div>
    );
};

export default AnalisisRiesgo;
